const points = {
  title: '积分记录',
  all: '全部',
  balance: {
    contact: '联系方式积分',
    aiMatch: 'AI 积分',
  },
  balanceSummary: {
    title: '当前积分余额',
    description: '查看可用于联系方式获取与候选人分析的剩余积分。',
  },
  usageTips: {
    title: 'AI 积分消耗说明',
    description: '以下场景按候选人数扣除 AI 积分',
    cost: '每人 1 AI 积分',
    tag: {
      title: '标签候选人分析',
      description: '分析是否为华人、是否有中企经历。',
    },
    job: {
      title: '岗位匹配分析',
      description: '分析候选人与岗位的匹配度。',
    },
    inmail: {
      title: 'AI InMail 生成',
      description: '为每位候选人生成一份 AI InMail 内容。',
    },
  },
  modes: {
    consume: '消耗记录',
    all: '全部流水',
  },
  filters: {
    typePlaceholder: '积分类型',
    actionPlaceholder: '场景',
    limitPlaceholder: '每页条数',
    limitOption: '{value} 条/页',
  },
  actions: {
    refresh: '刷新',
  },
  columns: {
    time: '时间',
    pointsType: '积分类型',
    scene: '场景',
    change: '变动',
    balanceBefore: '余额前',
    balanceAfter: '余额后',
    description: '说明',
  },
  types: {
    contact: '联系方式积分',
    aiMatch: 'AI 积分',
  },
  actionsMap: {
    recharge: '充值',
    member_reward: '会员奖励',
    referral_reward: '邀请奖励',
    system_gift: '系统赠送',
    special_purchase: '购买联系方式',
    system_recycle: '系统扣除',
    ai_match: 'AI匹配分析',
    resume_import: '导入简历',
    inmail_generation: '生成 InMail',
  },
  subject: {
    candidate: '候选人：{name}',
    generic: '{type}：{name}',
    relatedCandidates: '关联候选人（{count}）：{names}{suffix}',
    moreSuffix: ' 等',
  },
  empty: '暂无积分记录',
  errors: {
    balance: '积分余额加载失败',
    records: '积分记录加载失败',
  },
}

export default points
